"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const range_1 = __importDefault(require("lodash/range"));
const usePages = ({ currentPage, hideFirstPage, hideLastPage, numLeadingPages, numTrailingPages, pageCount }) => {
    const pages = react_1.default.useMemo(() => {
        if (currentPage < 0 || pageCount <= 0 || currentPage >= pageCount) {
            return [];
        }
        const start = Math.max(currentPage - numLeadingPages, 1);
        const end = Math.min(currentPage + numTrailingPages + 1, pageCount - 1);
        // Build pages between ellipsis
        const intermediatePages = (0, range_1.default)(start, end, 1).map((num) => ({
            key: num,
            label: num + 1,
            value: num,
            isCurrent: num === currentPage,
            isClickable: num !== currentPage,
            isDisabled: false
        }));
        // Show leading ellipsis if first intermediate page is more than number of leading pages away from the first page
        const showLeadingEllipsis = (currentPage > 1 ||
            (intermediatePages[0] && intermediatePages[0].value > 1)) &&
            currentPage - numLeadingPages > 1;
        // Show trailing ellipsis if last intermediate page is more than number of trailing pages away from the last page
        const showTrailingEllipsis = (currentPage < pageCount - 2 ||
            (intermediatePages[intermediatePages.length - 1] &&
                intermediatePages[intermediatePages.length - 1].value <
                    pageCount - 2)) &&
            currentPage + numTrailingPages < pageCount - 2;
        const currPages = [];
        if (!hideFirstPage) {
            currPages.push({
                key: 0,
                label: 1,
                value: 0,
                isCurrent: 0 === currentPage,
                isClickable: 0 !== currentPage,
                isDisabled: false
            });
        }
        if (showLeadingEllipsis) {
            currPages.push({
                key: 'ell-1',
                label: '...',
                value: -1,
                isCurrent: false,
                isClickable: false,
                isDisabled: true
            });
        }
        currPages.push(...intermediatePages);
        if (showTrailingEllipsis) {
            currPages.push({
                key: 'ell-2',
                label: '...',
                value: -1,
                isCurrent: false,
                isClickable: false,
                isDisabled: true
            });
        }
        if (!hideLastPage && pageCount - 1 > 0) {
            currPages.push({
                key: pageCount - 1,
                label: pageCount,
                value: pageCount - 1,
                isCurrent: pageCount - 1 === currentPage,
                isClickable: pageCount - 1 !== currentPage,
                isDisabled: false
            });
        }
        return currPages;
    }, [
        currentPage,
        hideFirstPage,
        hideLastPage,
        numLeadingPages,
        numTrailingPages,
        pageCount
    ]);
    return pages;
};
exports.default = usePages;
//# sourceMappingURL=usePages.js.map